module.exports = __webpack_public_path__ + "img/2.1f7e3466.png";